<template>
    <div class="mb-3.5 shine rounded-lg  overflow-hidden" />
</template>
